document.addEventListener("DOMContentLoaded", function () {
  footerAccordions();
  elementorTabsSetup();
  chatLinksSetup();
  tableScroll();
  cardSlides();
  wishlistSetup();
  variantsScrollFix();
  document.addEventListener("change", function (event) {
    const checkbox = event.target;
    if (
      checkbox.matches(".rebuy-cart__notes-toggle-input") &&
      checkbox.checked
    ) {
      const textarea = document.querySelector("#rebuy-cart__notes");
      if (textarea) {
        textarea.focus();
      }
    }
  });

  setTimeout(() => {
    if (document.querySelector('wjd-cart')) return;

    const oldLink = document.querySelector('.header__icon--cart');
    if (!oldLink) return;

    const newLink = oldLink.cloneNode(true);
    oldLink.parentNode.replaceChild(newLink, oldLink);

    newLink.addEventListener('click', (event) => {
      if (document.querySelector('wjd-cart')) return;

      if (typeof window.Rebuy?.SmartCart?.show === 'function') {
        event.preventDefault();
        window.Rebuy.SmartCart.show();
      }
    });
  }, 1000);
});
function swymCallbackFn(swat) {
  // your API calls go here
  document.addEventListener("swym:collections-loaded", function () {
    swat.initializeActionButtons(".boost-sd-container");
  });
}

function variantsScrollFix() {
  document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('select, input[type="radio"]');
    elements.forEach(function (el) {
      el.addEventListener('change', function () {
        const currentPos = window.scrollY || window.pageYOffset;
        document.documentElement.scrollTop = currentPos;
        document.body.scrollTop = currentPos; // for Safari
      });
    });
  });
}

function wishlistSetup() {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
}
var isShowMoreImagesEnabled = false;
function showMoreImages() {
  if (!isShowMoreImagesEnabled) {
    document
      .querySelector(".product__media-wrapper")
      .classList.add("show-images");
    document.querySelector(".load-more-images").innerText = "Show less images";
    isShowMoreImagesEnabled = true;
  } else {
    document
      .querySelector(".product__media-wrapper")
      .classList.remove("show-images");
    document.querySelector(".load-more-images").innerText = "Load more images";
    isShowMoreImagesEnabled = false;
  }
}
function cardSlides() {
  document.querySelectorAll(".dd.card__inner").forEach((carousel) => {
    const carouselInner = carousel.querySelector(
      ".shoptimizer-plp-image-wrapper"
    ); //hide-up
    const hideUp = carousel.querySelector(
      ".shoptimizer-plp-image-wrapper .hide-up"
    );
    const viewMore =
      '<div class="hide-up" style="width: 50% !important; display: none; position: relative !important; scroll-snap-align: center !important; flex-shrink: 0 !important; justify-content: center; align-items: center; "> <span style="border: 1px solid #c4c4c4; padding: 8px 15px; color: #222; font-size: 14px; font-weight: bold;">VIEW MORE</span> </div>';
    if (!hideUp) carouselInner.insertAdjacentHTML("beforeend", viewMore);
    const dots = carousel.querySelectorAll(".shoptimizer-plp-carousel--dot");
    const carouselContainer = carousel.querySelector(
      ".shoptimizer-plp-carousel-container"
    );

    // Check if the carousel container exists
    if (carouselContainer) {
      function updateDots() {
        const scrollLeft = carouselContainer.scrollLeft;
        const viewportWidth = carouselContainer.clientWidth;
        const index = Math.round(scrollLeft / viewportWidth);

        dots.forEach((dot, i) => {
          dot.classList.toggle("active", i === index);
        });
      }

      let isScrolling;
      carouselContainer.addEventListener("scroll", () => {
        clearTimeout(isScrolling);
        isScrolling = setTimeout(() => {
          updateDots();
        }, 50);
      });

      // Initialize the dots
      updateDots();
    } else {
      console.warn("Carousel container not found:", carousel);
    }
  });
}
function tableScroll() {
  document.querySelectorAll(".item_spec_tbl_cnt_multi").forEach(function (el) {
    const wrapper = document.createElement("div");
    wrapper.className = "scrollable-container";
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  });
}
function checkWishlist(event, wishRedirect) {
  if (document.querySelector(".st-is-added") && wishRedirect) {
    event.stopImmediatePropagation();
    window.location.href = "/pages/wishlist";
  }
}
function chatLinksSetup() {
  document.querySelectorAll('a[href="#openChat"]').forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      link.closest("[popover]")?.hidePopover();
      openChat();
    });
  });
}

function vimeoVideos() {
  document.querySelectorAll("[data-html]").forEach((el) => {
    el.innerHTML += el.getAttribute("data-html");
  });
}
function openChat() {
  const chat = document.querySelector("shopify-chat");
  if (chat) {
    const runtime = chat.shadowRoot?.querySelector("shopify-agent-runtime");
    const launcher = runtime?.shadowRoot?.querySelector('button[part~="activator"]')
      || chat.shadowRoot?.querySelector('button[part~="activator"]');
    if (launcher && launcher.getAttribute("aria-expanded") !== "true") {
      setTimeout(() => launcher.click(), 0);
    }
    return;
  }

  const legacyChat = document.querySelector("inbox-online-store-chat");
  const launcher = legacyChat?.shadowRoot?.querySelector("button");
  if (launcher) launcher.click();
}
function footerAccordions() {
  const accordions = document.querySelectorAll(".footer-block--menu");
  accordions.forEach((accordion) => {
    const heading = accordion.querySelector(".footer-block__heading");
    const details = accordion.querySelector(".footer-block__details-content");
    const plus = heading.querySelector(".d-plus");
    const minus = heading.querySelector(".d-minus");

    details.style.display = "none";
    minus.style.display = "none";

    heading.addEventListener("click", function () {
      const isOpen = details.style.display === "block";

      details.style.display = isOpen ? "none" : "block";
      plus.style.display = isOpen ? "inline" : "none";
      minus.style.display = isOpen ? "none" : "inline";
    });
  });
}
function elementorTabsSetup() {
  const tabs = document.querySelectorAll(".elementor-tab-title");
  const contents = document.querySelectorAll(".elementor-tab-content");
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const contentId = this.getAttribute("aria-controls");
      const content = document.getElementById(contentId);
      const isOpen = this.getAttribute("aria-expanded") === "true";

      tabs.forEach((t) => {
        t.classList.remove("elementor-active");
        t.setAttribute("aria-selected", "false");
        t.setAttribute("aria-expanded", "false");

        const closedIcon = t.querySelector(".elementor-accordion-icon-closed");
        const openedIcon = t.querySelector(".elementor-accordion-icon-opened");

        if (closedIcon) closedIcon.style.display = "inline";
        if (openedIcon) openedIcon.style.display = "none";
      });

      contents.forEach((c) => {
        c.style.display = "none";
        c.setAttribute("hidden", "hidden");
      });

      if (!isOpen) {
        this.classList.add("elementor-active");
        this.setAttribute("aria-selected", "true");
        this.setAttribute("aria-expanded", "true");

        const closedIcon = this.querySelector(
          ".elementor-accordion-icon-closed"
        );
        const openedIcon = this.querySelector(
          ".elementor-accordion-icon-opened"
        );

        if (closedIcon) closedIcon.style.display = "none";
        if (openedIcon) openedIcon.style.display = "inline";

        if (content) {
          content.style.display = "block";
          content.removeAttribute("hidden");
        }
      }
    });
  });
}

const input = document.querySelector(".header-search .field__label");
const input2 = document.querySelector(".header-search .search__input");
const placeholders = [
  "Discover your perfect piece!",
  "Find your jewelry style...",
  "What are you looking for today?",
  "Start your jewelry journey...",
  "Explore sparkling treasures!",
  "Unearth your unique style...",
  "Find the perfect gift!",
  "Search for timeless beauty...",
  "Which piece will you cherish?",
  "What jewelry dream are you chasing?",
  "Explore luxury for everyone!",
];

let currentIndex = 0;
let charIndex = 0;
let isDeleting = false;
const typingSpeed = 50;
const deletingSpeed = 25;
const pauseBetweenWords = 2000;
function typeEffect() {
  const currentPlaceholder = placeholders[currentIndex];
  if (!isDeleting) {
    charIndex++;
  } else {
    charIndex--;
  }
  if (input2.value == "") {
    input.innerText = ("placeholder", currentPlaceholder.slice(0, charIndex));
  } else {
    input.innerText = "";
    setTimeout(() => {
      typeEffect();
    }, 2000);
    return;
  }
  if (!isDeleting && charIndex === currentPlaceholder.length) {
    setTimeout(() => {
      isDeleting = true;
      typeEffect();
    }, pauseBetweenWords);
    return;
  } else if (isDeleting && charIndex === 0) {
    isDeleting = false;
    currentIndex = (currentIndex + 1) % placeholders.length;
  }
  const speed = isDeleting ? deletingSpeed : typingSpeed;

  setTimeout(typeEffect, speed);
}
// Keep the header search placeholder steady.


